import script from "./QrCode.vue?vue&type=script&setup=true&lang=js"
export * from "./QrCode.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__